import { useMemo } from 'react'
import { calcPractice } from './ggPractice.js'
import { samplePlayers } from './ggSamplePlayers.js'

// G-Practice — isolated sandbox. Practice Round has no betting; mirrors
// GolfGamesScorecard (routes to gross-total standings, no payouts).
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GPractice() {
  const rows = useMemo(() => calcPractice(samplePlayers()), [])
  return (
    <div className="card">
      <p className="text-sm text-gray-500 mb-3">Practice Round — no wager. Gross totals shown for reference only.</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>
          {['Pos', 'Player', 'Total'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}
        </tr></thead>
        <tbody>{rows.map((p, i) => (
          <tr key={p.id}><td style={cell}>{i + 1}</td><td style={cell}>{p.name}</td><td style={cell}><b>{p.total}</b></td></tr>
        ))}</tbody>
      </table>
    </div>
  )
}
